import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Card, Row, Col, Statistic, Progress, Typography } from "antd";
import { TeamOutlined, CheckCircleOutlined, StarOutlined } from "@ant-design/icons";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Paragraph } = Typography;
const StatsSection = ({
  darkMode,
  learnerCount,
  learnerMonthCount,
  inflightCount,
  performanceRating,
  completedCount,
  performanceRatingCount,
}) => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const cardStyle = {
    borderRadius: 12,
    marginBottom: 6,
    backgroundColor: darkMode ? "#1f1f1f" : "#fff",
    borderColor: darkMode ? "#303030" : "#f0f0f0",
    opacity: isBlocked ? 0.6 : 1,
    PointerEvent: isBlocked ? "none" : "auto"
  };
  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} sm={12} md={6}>
        <Card hoverable style={cardStyle}>
          <Statistic
            title={
              <span
                style={{
                  color: darkMode ? "#fff" : "#1890ff",
                }}
              >
                Active Learners
              </span>
            }
            value={learnerCount}
            prefix={<TeamOutlined />}
            valueStyle={{ color: "#1890ff" }}
          />
          <Progress percent={learnerCount} showInfo={false} strokeColor="#1890ff" />
          <Paragraph
            type="secondary"
            style={{ color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)" }}
          >
            +{learnerMonthCount} from last month
          </Paragraph>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card hoverable style={cardStyle}>
          <Statistic
            title={
              <span
                style={{
                  color: darkMode ? "#fff" : "#52c41a",
                }}
              >
                Training Inflight
              </span>
            }
            value={inflightCount}
            prefix={<CheckCircleOutlined />}
            valueStyle={{ color: "#52c41a" }}
          />
          <Progress percent={inflightCount} showInfo={false} strokeColor="#52c41a" />
          <Paragraph
            type="secondary"
            style={{ color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)" }}
          >
            Active training sessions
          </Paragraph>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card hoverable style={cardStyle}>
          <Statistic
            title={
              <span
                style={{
                  color: darkMode ? "#fff" : "#faad14",
                }}
              >
                Performance Rating
              </span>
            }
            value={performanceRating}
            prefix={<StarOutlined />}
            valueStyle={{ color: "#faad14" }}
            suffix="/5"
          />
          <Progress percent={performanceRating * 20} showInfo={false} strokeColor="#faad14" />
          <Paragraph
            type="secondary"
            style={{ color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)" }}
          >
            Rated By Learners {performanceRatingCount}
          </Paragraph>
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card hoverable style={cardStyle}>
          <Statistic
            title={
              <span
                style={{
                  color: darkMode ? "#fff" : "#722ed1",
                }}
              >
                Completed Trainings
              </span>
            }
            value={completedCount}
            prefix={<CheckCircleOutlined />}
            valueStyle={{ color: "#722ed1" }}
          />
          <Progress percent={completedCount} showInfo={false} strokeColor="#722ed1" />
          <Paragraph
            type="secondary"
            style={{ color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)" }}
          >
            Recently completed
          </Paragraph>
        </Card>
      </Col>
    </Row>
  );
};
StatsSection.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  learnerCount: PropTypes.number.isRequired,
  learnerMonthCount: PropTypes.number.isRequired,
  inflightCount: PropTypes.number.isRequired,
  performanceRating: PropTypes.number.isRequired,
  completedCount: PropTypes.number.isRequired,
  performanceRatingCount: PropTypes.number.isRequired,
};
export default StatsSection;
